import { request } from '@/util/http'

const BASE_URL = '/api/ClockIn'

const parseDepartment = (dep) => {
  if (!dep && dep !== 0) return ''
  if (Array.isArray(dep)) {
    return dep[0] || ''
  }
  return dep
}

export function ensureClockInUser() {
  let data = null
  const raw = localStorage.getItem('userinfo')
//   const raw = {
//     "message": "授权成功",
//     "success": true,
//     "code": 200,
//     "data": {
//         "errcode": 0,
//         "errmsg": "ok",
//         "userid": "2017551",
//         "name": "吴昌悦",
//         "department": [
//             3858
//         ],
//         "position": "",
//         "mobile": "15812615614",
//         "gender": "1",
//         "email": "",
//         "avatar": "https://wework.qpic.cn/wwpic3az/64935_9kGeUfUKQGmGpYT_1764829263/0",
//         "status": 1,
//         "isleader": 0,
//         "extattr": {
//             "attrs": [
//                 {
//                     "name": "工号",
//                     "value": "2017551",
//                     "type": 0,
//                     "text": {
//                         "value": "2017551"
//                     }
//                 },
//                 {
//                     "name": "英文名",
//                     "value": "",
//                     "type": 0,
//                     "text": {
//                         "value": ""
//                     }
//                 },
//                 {
//                     "name": "身份证",
//                     "value": "",
//                     "type": 0,
//                     "text": {
//                         "value": ""
//                     }
//                 },
//                 {
//                     "name": "岗位标签",
//                     "value": "",
//                     "type": 0,
//                     "text": {
//                         "value": ""
//                     }
//                 }
//             ]
//         },
//         "english_name": "",
//         "telephone": "",
//         "enable": 1,
//         "hide_mobile": 0,
//         "order": [
//             0
//         ],
//         "external_profile": {
//             "external_attr": [],
//             "external_corp_name": ""
//         },
//         "main_department": 3858,
//         "qr_code": "https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc19aa777555565206",
//         "alias": "",
//         "is_leader_in_dept": [
//             0
//         ],
//         "address": "",
//         "thumb_avatar": "https://wework.qpic.cn/wwpic3az/64935_9kGeUfUKQGmGpYT_1764829263/100",
//         "direct_leader": [],
//         "openid": "ozAQBt9Jauj5fMYuM9Q0bNmhaAo8",
//         "area": "总部",
//         "departmentName": "营销支持部"
//     },
//     "access_token": "znZqJK6bgroAB67iYDQAsWGigMzMUb8__3ZpLmJ08c2wLwJLGVackp7cYJJPIhlxYAFG1r6B5Pyyl4NWV5OdxZ2AL4yTNbhLWuJCuPlblOElwLfZBV_PVm40mYdVVe9ji5JRfD5nVFbCu5vIuejSj9HMEXYnTxs5BsINnq-fvIqlu7j0y_z2y8D-K1YTJNRhm90IlSXwFYTmmf5Cr7Dyig"
// }
  if (raw) {
    try {
      const parsed = JSON.parse(raw)
      data = parsed?.data || null
    } catch (e) {
      console.warn('解析 userinfo 失败', e)
    }
  }

  const fallbackId = localStorage.getItem('UserId')
  if (!data && !fallbackId) {
    throw new Error('未获取到登录信息，请先完成登录授权')
  }

  const user = data || {}
  const area = user.area || localStorage.getItem('Area') || ''

  return {
    id: user.userid || fallbackId || '',
    userId: user.userid || fallbackId || '',
    name: user.name || localStorage.getItem('UserName') || '',
    deptId: user.deptId || parseDepartment(user.department) || '',
    deptName: user.departmentName || '',
    area,
    avatar: user.avatar || '',
    raw: user
  }
}

export function buildUserPayload(extra = {}) {
  const user = ensureClockInUser()
  return {
    UserId: user.id,
    UserName: user.name,
    DeptName: user.deptName,
    DeptId: user.deptId,
    Avatar: user.avatar,
    Area: user.area,
    ...extra
  }
}

export async function clockInRequest(options) {
  const res = await request({
    ...options,
    url: `${BASE_URL}${options.url}`
  })
  if (!res.success) {
    throw new Error(res.message || '接口调用失败')
  }
  return res
}

export const normalizeRecord = (item = {}) => ({
  id: item._id || item.id,
  user: {
    id: item.UserId,
    name: item.UserName,
    dept: item.DeptName || item.Area || '',
    avatar: item.Avatar
  },
  area: item.Area || '',
  note: item.Note || '',
  score: item.Score || 0,
  image_urls: item.ImageUrls || [],
  created_at: item.CreatedAt || item.created_at || '',
  raw: item
})

export const normalizeMaterial = (item = {}) => ({
  id: item._id || item.id,
  user: {
    id: item.UserId,
    name: item.UserName,
    dept: item.DeptName || item.Area || ''
  },
  content: item.Content || '',
  image_urls: item.ImageUrls || [],
  status: item.Status || 'pending',
  created_at: item.CreatedAt || item.created_at || '',
  raw: item
})

export const normalizeScoreRow = (item = {}) => {
  const normalized = {
    user_id: item.UserId,
    name: item.UserName || '未命名',
    dept: item.DeptName || item.Area || '',
    forward_rate: Number(item.ForwardRate || 0),
    selected_clues: Number(item.SelectedClues || 0),
    score: Number(item.Score || 0),
    avatar: item.Avatar || '',
    area: item.Area || '',
    raw: item
  }
  return normalized
}

